<template>
  <div
    class="fuid-finPrematriculas d-flex flex-column justify-content-center align-items-center"
  >
    <b-container class="container-redo">
      <b-row class="fuid-finPrematriculas_container">
        <b-col>
          <h1 class="text-center">{{ $t(title) }}</h1>

          <h4 class="text-center">{{ $t(message) }}</h4>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.fuid-finPrematriculas {
  background-color: #f2f2f2;
  min-height: calc(100vh - 350px);

  h1 {
    font-family: Poppins, Arial, sans-serif;
    font-size: 1.5rem;
    font-weight: 700;
    border-bottom: 3px solid #000;
    padding-bottom: 1rem;
    margin-bottom: 1.5rem;
  }

  h4 {
    font-family: Poppins, Arial, sans-serif;
    font-size: 1.2rem;
  }

  @media (min-width: 992px) {
    h1 {
      font-size: 3rem;
    }

    h4 {
      font-size: 1.1rem;
    }
  }
}
</style>
